import * as React from "react";
import { IS_HUBSPOT_INTEGRATION_ENABLED, REFERRAL_SERVICE_PARTNER_URL } from "../../../envVariables";
import { useAppSelector } from "../../../store/hooks";
import { selectIsCplnTeam } from "../../../store/userSlice";
import { selectHasAccount, selectHasOrg } from "../../../store/userDataSlice";
import { request } from "../../../services/cpln";
import { getReferralCookies } from "../../../services/utils";
import { store } from "../../../store";
import { BillingAccountCreateInput } from "./input";

export function useInformExternal(formId: string) {
  const isCplnTeam = useAppSelector(selectIsCplnTeam);
  const hasAccount = useAppSelector(selectHasAccount);
  const hasOrg = useAppSelector(selectHasOrg);
  const userEmail = useAppSelector((state) => state.user.email);

  const [isDone, setIsDone] = React.useState(false);

  function getSkip() {
    return !IS_HUBSPOT_INTEGRATION_ENABLED || isCplnTeam || hasAccount || hasOrg;
  }
  const [skip, setSkip] = React.useState(getSkip());
  React.useEffect(() => {
    setSkip(getSkip());
  }, [isDone, isCplnTeam, hasAccount, hasOrg]);

  React.useEffect(() => {
    if (skip || !isDone) {
      return;
    }
    inform();
  }, [isDone, skip]);

  async function inform() {
    const form = store.getState().form.instances[formId];
    if (!form) return;
    const values = form.values as BillingAccountCreateInput & { meta: { externalId?: string } };
    const accountId = values.meta?.createdAccount?.id;
    if (!accountId) return;

    const externalId = values.meta?.externalId || "";
    if (externalId) {
      await tryInformExternalForm(accountId, externalId);
    } else {
      await tryInformExternalCookie(accountId, userEmail);
    }
  }

  return { setIsDone, inform };
}

async function tryInformExternalForm(accountId: string, externalId: string) {
  try {
    await request({
      method: "patch",
      url: `${REFERRAL_SERVICE_PARTNER_URL}/referral/${externalId}`,
      service: "self",
      body: { status: "created", accountId },
    });
  } catch (e) {
    console.error("Failed to inform external for form");
  }
}

async function tryInformExternalCookie(accountId: string, userEmail: string) {
  try {
    const cookies = getReferralCookies();
    await request({
      method: "post",
      url: `${REFERRAL_SERVICE_PARTNER_URL}/cookieReferral`,
      service: "self",
      body: { accountId, email: userEmail, ...cookies },
    });
  } catch (e) {
    console.error("Failed to inform external for cookie");
  }
}
